/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreHistoryManagementShowItemResponse } from './StoreHistoryManagementShowItemResponse';

export type StoreHistoryManagementShowItemResponseApiRespoonse = {
    data?: StoreHistoryManagementShowItemResponse;
    status?: StoreHistoryManagementShowItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreHistoryManagementShowItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

